<template>
  <div class="requests" style="margin-top: -1rem">
    <b-modal ref="warningModal" ok-title="Continue" title="Confirm Request" header-bg-variant="warning"
             @cancel="closeWarningModal"
             @ok="showWarningMessages($event)">
      <h5>{{ this.warningMessage }}</h5>
      <h5>Are you sure you want to continue?</h5>
    </b-modal>
    <MatchingTripsModal ref="matchingTripsModal"></MatchingTripsModal>
    <CCard borderColor="white">
      <CCardHeader borderColor="white">
        <div class="row">
          <div class="col-sm-5">
            <span class="lr-modal-title">POST A REQUEST</span>
          </div>
          <div class="col-sm-6  d-flex justify-content-end" style="margin: 0 auto" v-if="this.request.created_at">
            <div>Request posted on: {{this.dateTimeFormat(this.request.created_at)}} EST</div>
          </div>
        </div>
      </CCardHeader>
      <CCardBody style="padding-top: 0">
        <div class="row">
          <div class="col-11" style="margin: 0 auto">
            <form ref="form" @submit.stop.prevent="onSubmit" class="load-request-form">
              <div class="container-fluid">
                <div class="row bg-row">
                  <div class="col-sm-6">
                    <b-form-group>
                      <label>Work Type</label>
                      <VSelect :disabled="this.disabled" v-model="selectedWorkType" multiple
                               placeholder="Select work type"
                               :options="workTypeList"></VSelect>
                    </b-form-group>
                  </div>
                  <div class="col-sm-6">
                    <div class="row">
                      <div class="col-sm-6">
                        <b-form-group>
                          <label>Equipment</label>
                          <VSelect :disabled="this.disabled" v-model="selectedEquipments" multiple
                                   placeholder="Select work type"
                                   :options="equipments"></VSelect>
                        </b-form-group>
                      </div>
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Min Stop</label>
                          <b-form-select :disabled="this.disabled" v-model="request.stops.min"
                                         @input="validateStops()" ref="stopMin">
                            <option :value=0>Any</option>
                            <option v-for="option in 9" :value="option + 1" :key="option">
                              {{ option + 1 }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Max Stop</label>
                          <b-form-select :disabled="this.disabled" v-model="request.stops.max"
                                         @input="validateStops()" ref="stopMax">
                            <option :value=0>Any</option>
                            <option v-for="option in 11" :value="option + 1" :key="option + 30">
                              {{ option + 1 }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row bg-row">
                  <div class="col-sm-6">
                    <div class="row">
                      <div class="col-sm-8">
                        <b-form-group>
                          <label>Origin</label>
                          <VSelect :disabled="this.disabled" ref="origin"
                                   :class="{'is-invalid': $v.selectedOrigin.$error}"
                                   @search="searchLocations($event, 'origin')"
                                   @search:focus="searchLocations($event, 'origin')"
                                   v-model="selectedOrigin"
                                   placeholder="Enter Origin City (Pickup Location)"
                                   :options="origins">
                          </VSelect>
                        </b-form-group>
                      </div>
                      <div class="col-sm-4">
                        <b-form-group>
                          <label>PU Radius <i id="info-tooltip-radius"
                                              class="fa fa-info-circle info-icon-color"></i></label>
                          <b-tooltip target="info-tooltip-radius" title="Pickup Radius" triggers="hover">
                            Enter any mileage minimum 25, up to 100
                          </b-tooltip>
                          <b-form-input type="number" :class="{'is-invalid': $v.request.radius.$error}"
                                        v-on:keypress="onlyNumber"
                                        number
                                        placeholder="PU Radius"
                                        :disabled="this.disabled"
                                        v-model="request.radius">
                          </b-form-input>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <b-form-group>
                          <label class="text-red">Excluded Origins</label>
                          <VSelect class="excluded-input" :disabled="this.disabled" ref="excludedOrigins"
                                   multiple
                                   @search="searchLocations($event, 'excludedOrigins')"
                                   @search:focus="searchLocations($event, 'excludedOrigins')"
                                   v-model="selectedExcludedOrigins"
                                   placeholder="Enter states or cities to exclude (for pickup)"
                                   :options="excludedOrigins">
                          </VSelect>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-7">
                        <b-form-group :class="{'no-bottom-space': request.stemTime > 0 || request.perDeadheadMileSec > 0}">
                          <label>Deadhead time Min. (per mile) <i id="perDeadHeadMileSec-info" class="fa fa-info-circle info-icon-color"></i></label>
                          <b-tooltip custom-class="stem-time-info" target="perDeadHeadMileSec-info" triggers="hover">
                            This is in seconds how much per mile time driver needs to travel from requested location to pick up. For example say 60 seconds (1 min) is selected and dead head mile is 37miles (that is the distance from Requested origin to pick up location). This means driver needs at least 37minutes to travel to pick up location. Then system books this load if pick up time is  at least 37 min from now.
                          </b-tooltip >
                          <b-form-select :disabled="this.disabled || request.stemTime > 0" v-model="request.perDeadheadMileSec">
                            <option :value=0>Please select</option>
                            <option v-for="option in perDeadHeadSeconds" :value="option.value" :key="option.value + 500">
                              {{ option.text }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </div>
                      <div class="col-sm-5">
                        <b-form-group :class="{'no-bottom-space': request.stemTime > 0 || request.perDeadheadMileSec > 0}">
                          <label>Stem time Min.<i id="stem-time-info"
                                                   class="fa fa-info-circle info-icon-color"></i></label>
                          <b-tooltip custom-class="stem-time-info" target="stem-time-info" title="Min. stem time" triggers="hover">
                            Post a request won't match a trip if it departs earlier than the minimum stem time needed for the driver to travel to the origin
                          </b-tooltip>
                          <b-form-select :disabled="this.disabled || request.perDeadheadMileSec > 0" v-model="request.stemTime">
                            <option :value=0>Please select</option>
                            <option v-for="option in stemTimeList" :value="option.value" :key="option.value + 100">
                              {{ option.text }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row" v-if="request.perDeadheadMileSec > 0">
                      <div class="col-sm-12">
                        <span class="orange-text" v-if="request.perDeadheadMileSec > 0"><i>Example</i>: It takes {{ (request.perDeadheadMileSec * 20 / 60).toFixed(2) }} minutes to get 20 miles deadhead to pickup. If Pickup time is less than {{ (request.perDeadheadMileSec * 20 / 60).toFixed(2) }} minutes from now then load won't be booked</span>
                      </div>
                    </div>
                    <div class="row" v-else-if="request.stemTime > 0">
                      <div class="col-sm-12">
                        <span class="orange-text" v-if="request.stemTime > 0"><i>Example</i>: If Pickup time is less than {{ request.stemTime }} minutes from now then load won't be booked</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="row">
                      <div class="col-sm-8">
                        <b-form-group>
                          <label>Destinations</label>
                          <VSelect :disabled="this.disabled" ref="destinations"
                                   multiple
                                   @search="searchLocations($event, 'destinations')"
                                   @search:focus="searchLocations($event, 'destinations')"
                                   v-model="selectedDestinations"
                                   placeholder="Enter states or cities (delivery locations)"
                                   :options="multiplDestinations">
                          </VSelect>
                        </b-form-group>
                      </div>
                      <div class="col-sm-4">
                        <b-form-group>
                          <label>Exclude <br> non-destinations <i id="info-tooltip-non-dest"
                                                                  class="fa fa-info-circle info-icon-color"></i></label>
                          <b-tooltip target="info-tooltip-non-dest" title="Exclude non destinations" triggers="hover">
                            Any location that is not in the destinations list is treated as an excluded location
                          </b-tooltip>
                          <b-form-checkbox
                            :disabled="this.disabled || request.stops.max === 2 || selectedDestinations.length === 0"
                            v-model="request.excludeNonDestinations"/>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <b-form-group>
                          <label class="text-red">Excluded Destinations</label>
                          <VSelect class="excluded-input" :disabled="this.disabled" ref="excludedDestinations"
                                   multiple
                                   @search="searchLocations($event, 'excludedDestinations')"
                                   @search:focus="searchLocations($event, 'excludedDestinations')"
                                   v-model="selectedExcludedLocations"
                                   placeholder="Enter states or cities to exclude (for delivery)"
                                   :options="excludedDestinations">
                          </VSelect>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <b-form-group>
                          <label class="text-red">Excluded Facilities</label>
                          <VSelect class="excluded-input" :disabled="this.disabled" ref="excludedFacilities"
                                   multiple
                                   @search="searchWarehouses($event)"
                                   @search:focus="searchWarehouses($event)"
                                   v-model="selectedExcludedFacilities"
                                   placeholder="Enter Facilities' Codes to exclude (for delivery)"
                                   :options="excludedFacilities">
                          </VSelect>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row bg-row">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Additional settings</label>
                          <b-form-checkbox :disabled="this.disabled" v-model="request.emptyTrailerOnly">
                            Book only empty trailer
                          </b-form-checkbox>
                          <b-form-checkbox id="ignoreItr" :disabled="this.disabled" v-model="request.excludeITR">
                            Ignore Recovery Loads (ITR)
                          </b-form-checkbox>
                          <b-form-checkbox id="ignoreThirdParty" :disabled="this.disabled"
                                           v-model="request.ignoreThirdPartyLoad">
                            Ignore 3rd Party Loads
                          </b-form-checkbox>
                        </b-form-group>
                      </div>
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Trailer Status</label>
                          <b-form-checkbox-group
                            :disabled="this.disabled"
                            v-model="selectedStatus"
                            :options="statusList"
                            stacked></b-form-checkbox-group>
                        </b-form-group>
                      </div>
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Payout (Min Amount)</label>
                          <b-input-group prepend="$">
                            <b-form-input type="number" ref="price" @input="changePrice($event, 'price')"
                                          :min="0"
                                          number
                                          v-on:input="$v => this.request.price = +$v"
                                          placeholder="Min"
                                          :disabled="this.disabled"
                                          v-model="request.price">
                            </b-form-input>
                          </b-input-group>
                          <span class="small text-danger" v-if="priceError">The price entered is too low</span>
                        </b-form-group>
                      </div>
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Per Mile Rate (Min Rate)</label>
                          <b-input-group prepend="$">
                            <b-form-input type="number" ref="pricePerMile" @input="changePrice($event, 'pricePerMile')"
                                          :min="0"
                                          number step="any"
                                          v-on:input="$v => this.request.pricePerDistance = +$v"
                                          placeholder="Min"
                                          :disabled="this.disabled"
                                          v-model="request.pricePerDistance">
                            </b-form-input>
                          </b-input-group>
                          <span class="small text-danger" v-if="pricePerMilError">The price entered is too low</span>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Load Type</label>
                          <b-form-checkbox-group
                            :disabled="this.disabled"
                            v-model="selectedLoadType"
                            :options="typeList"
                            stacked></b-form-checkbox-group>
                        </b-form-group>
                      </div>
                      <div class="col-sm-3">
                        <b-form-group>
                          <label>Driver Type</label>
                          <b-form-checkbox-group
                            :disabled="this.disabled"
                            v-model="selectedDriverType"
                            :options="driverTypeList"
                            stacked></b-form-checkbox-group>
                        </b-form-group>
                      </div>
                      <div class="col-sm-3">
                        <div class="row">
                          <div class="col">
                            <b-form-group>
                              <label>Min Duration</label>
                              <b-form-input type="number" :min="0" number
                                            v-on:input="$v => this.request.duration.min = +$v"
                                            placeholder="Hours (min)" :disabled="this.disabled"
                                            v-model="request.duration.min"></b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col">
                            <b-form-group>
                              <label>Max Duration</label>
                              <b-form-input type="number" :min="0" number
                                            v-on:input="$v => this.request.duration.max = +$v"
                                            placeholder="Hours (max)" :disabled="this.disabled"
                                            v-model="request.duration.max"></b-form-input>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="row">
                          <div class="col">
                            <b-form-group>
                              <label>Min Mileage</label>
                              <b-form-input :min="0" type="number" number
                                            v-on:input="$v => this.request.distance.min = +$v"
                                            placeholder="Miles (min)"
                                            :disabled="this.disabled"
                                            v-model="request.distance.min"></b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col">
                            <b-form-group>
                              <label>Max Mileage</label>
                              <b-form-input :min="0" type="number" number
                                            v-on:input="$v => this.request.distance.max = +$v"
                                            placeholder="Miles (max)" :disabled="this.disabled"
                                            v-model="request.distance.max"></b-form-input>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row bg-row">
                  <div class="col-sm-6">
                    <div class="row">
                      <div class="col-sm-6">
                        <b-form-group>
                          <label>Departure Date <i id="info-tooltip-departure"
                                                   class="fa fa-info-circle info-icon-color"></i>
                            <span class="small font-italic" v-if="hourDiff"> (~ {{
                                this.hourDiff
                              }} from now)</span></label>
                          <b-tooltip target="info-tooltip-departure" title="Departure time" triggers="hover">
                            Once provided departure time arrives system uses current time as departure time.
                          </b-tooltip>
                          <b-form-datepicker @input="resetDeparture" :disabled="this.disabled"
                                             v-model="selectedStartDate"
                                             today-button
                                             reset-button
                                             close-button size="xl" placeholder="MM/dd/YYYY" :min="min"
                                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                          ></b-form-datepicker>
                        </b-form-group>
                      </div>
                      <div class="col-sm-6">
                        <b-form-group>
                          <label>Departure time</label>
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              <i class="fa-lg far fa-clock"></i>
                            </b-input-group-prepend>
                            <b-form-select :disabled="this.disabled" :options="hourMinutes"
                                           v-model="selectedTime"
                                           @input="updateHourDiff">
                            </b-form-select>
                          </b-input-group>
                        </b-form-group>
                      </div>
                      <small v-if="hourDiff" style="margin: -14px 0 0 14px;">
                        <i>Once provided departure time arrives system uses current time as departure time.</i>
                      </small>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group>
                      <label>Time Zone</label>
                      <b-form-select @input="updateHourDiff" class="time-zone-select" :disabled="this.disabled"
                                     v-model="request.timeZone"
                                     :options="timeZones"/>
                    </b-form-group>
                  </div>
                  <div class="col-sm-3">
                    <b-form-group>
                      <label>Departs</label>
                      <b-form-select :disabled="this.disabled" v-model="request.withinHours">
                        <option :value=0>Anytime</option>
                        <option v-for="hour in hours" :value="hour.value" :key="hour.value">
                          {{ 'Within ' + hour.text }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div class="row bg-row">
                  <div class="col-sm-6">
                    <b-form-group>
                      <label>Assign Drivers</label>
                      <VSelect ref="drivers" :disabled="this.disabled" multiple
                               v-model="selectedDrivers" :options="driverList"
                               @search="searchDrivers($event)"
                               @search:focus="searchDrivers($event)"
                               placeholder="Search drivers"></VSelect>
                    </b-form-group>
                  </div>
                  <div class="col-sm-6 d-flex justify-content-end">
                    <div class="row align-items-end">
                      <router-link type="cancel" class="btn btn-lg mr-2 btn-secondary" to="/requests">Cancel
                      </router-link>
                      <b-button :disabled="!this.selectedOrigin" v-if="this.showMatchingTrips" v-on:click="showMatchingTripModal()" class="btn-lg mr-2 btn-info">Matching Trips
                      </b-button>
                      <b-button :disabled="!this.selectedOrigin || this.submitted" v-if="!this.disabled" class="mr-2" size="lg" variant="success" type="submit">
                        {{ this.id && !this.cloneRequest ? 'Update' : 'Create' }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </CCardBody>
    </CCard>
    <div :class="{ invisible: !hasMatches }" v-if="this.id > 0">
      <div class="lr-modal-title">MATCHES</div>
      <div class="row">
        <div class="col-11" style="margin: 0 auto">
          <TripsListPage @totalCount="totalCount" :from-request="true" :requestId="this.id"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { between, required } from 'vuelidate/lib/validators'
import moment from 'moment-timezone'
import TripsListPage from '../trips/TripsListPage'
import {
  DEFAULT_JSON,
  DISTANCES,
  DRIVER_TYPES,
  EQUIPMENTS,
  HOUR_OPTIONS,
  LOAD_TYPES,
  PER_DEADHEAD_SECOND,
  STATUS,
  STEM_TIME,
  TIME_ZONES,
  TRAILER_28_STR,
  TRAILER_53_STR,
  TRIP_LENGTH_TYPE,
  WORK_TYPES
} from './loadboardConstans'
import {
  ACTIVE_REQUESTS,
  COMPLETED_REQUESTS,
  HOUR_FORMAT,
  INACTIVE_REQUESTS,
  LONG_DATE_FORMAT,
  MAX_PRICE_PER_MILE,
  MIN_PRICE,
  MIN_PRICE_PER_MILE,
  REQUEST_STATUS_ACTIVE,
  SHORT_DATE_FORMAT,
  WARNING_PRICE
} from '../../constants'
import { STATES } from '@/components/helper/states'
import closeMixin from '@/mixins/close.js'
import MatchingTripsModal from '@/views/loadrequest/MatchingTripsModal'

export default {
  mixins: [closeMixin],
  name: 'PostARequest',
  created () {
    this.loadTimeOptions()
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id)
    } else if (this.$route.query.request_id) {
      this.id = parseInt(this.$route.query.request_id)
      this.cloneRequest = true
      this.disabled = false
    }
    this.loadRequest()
  },
  components: {
    MatchingTripsModal,
    TripsListPage
  },
  data () {
    const today = moment.tz('America/Los_Angeles').format(SHORT_DATE_FORMAT)
    return {
      id: 0,
      hasMatches: false,
      cloneRequest: false,
      emptyDestination: false,
      radiusOk: false,
      tripLengthOk: false,
      hourDiff: '',
      min: today,
      hourMinutes: [],
      warningMessage: '',
      status: REQUEST_STATUS_ACTIVE,
      disabled: true,
      selectedWorkType: [
        { value: 'ONE_WAY', label: 'One-way' },
        { value: 'ROUND_TRIP', label: 'Round-trips' }
      ],
      selectedEquipments: [EQUIPMENTS.TRAILER_53],
      selectedOrigin: null,
      origins: [],
      multiplDestinations: [],
      selectedDestinations: [],
      excludedDestinations: [],
      excludedFacilities: [],
      selectedExcludedFacilities: [],
      excludedOrigins: [],
      selectedExcludedLocations: [],
      selectedExcludedOrigins: [],
      selectedStartDate: null,
      selectedTime: null,
      selectedStatus: ['PROVIDED'],
      selectedLoadType: ['DROP'],
      selectedDriverType: ['TEAM_DRIVER', 'SINGLE_DRIVER'],
      request: JSON.parse(JSON.stringify(DEFAULT_JSON)),
      workTypeList: WORK_TYPES,
      equipments: [EQUIPMENTS.TRUCK_26, EQUIPMENTS.TRAILER_28, EQUIPMENTS.TRAILER_53, EQUIPMENTS.CONTAINER_53],
      timeZones: TIME_ZONES,
      hours: HOUR_OPTIONS,
      distances: DISTANCES,
      statusList: STATUS,
      typeList: LOAD_TYPES,
      driverTypeList: DRIVER_TYPES,
      driverList: [],
      selectedDrivers: [],
      tripLengthTypes: TRIP_LENGTH_TYPE,
      stemTimeList: STEM_TIME,
      perDeadHeadSeconds: PER_DEADHEAD_SECOND,
      submitted: false,
      priceError: false,
      pricePerMilError: false
    }
  },
  methods: {
    totalCount (value) {
      this.hasMatches = value > 0
    },
    showMatchingTripModal () {
      const reqObj = this.buildRequestObject()
      this.$refs.matchingTripsModal.show(reqObj)
    },
    loadRequest () {
      if (!this.id) {
        this.disabled = false
        return
      }
      this.$loading.show()
      this.axios.get('api/request/' + this.id)
        .then(response => {
          if (response.status === 200) {
            this.request = response.data.data
            this.status = this.request.status
            this.disabled = this.status === COMPLETED_REQUESTS
            if (this.request.origin) {
              this.selectedOrigin = {
                label: this.request.origin
              }
            }
            const destinationList = this.request.destinations
            if (destinationList && destinationList.length > 0) {
              for (let i = 0; i < destinationList.length; i++) {
                this.selectedDestinations.push({ label: destinationList[i] })
              }
            }
            const excludedLocations = this.request.excludedLocations
            if (excludedLocations && excludedLocations.length > 0) {
              for (let i = 0; i < excludedLocations.length; i++) {
                this.selectedExcludedLocations.push({ label: excludedLocations[i] })
              }
            }
            const excludedFacilities = this.request.excludedFacilities
            if (excludedFacilities && excludedFacilities.length > 0) {
              for (let i = 0; i < excludedFacilities.length; i++) {
                this.selectedExcludedFacilities.push(excludedFacilities[i])
              }
            }
            const excludedOrigins = this.request.excludedOrigins
            if (excludedOrigins && excludedOrigins.length > 0) {
              for (let i = 0; i < excludedOrigins.length; i++) {
                this.selectedExcludedOrigins.push({ label: excludedOrigins[i] })
              }
            }
            if (!this.request.timeZone) {
              this.request.timeZone = 'America/Chicago'
            }
            if (this.request.startDate && !this.cloneRequest) {
              const startDate = moment(this.request.startDate).tz(this.request.timeZone)
              this.selectedStartDate = startDate.format(SHORT_DATE_FORMAT)
              this.selectedTime = startDate.format(HOUR_FORMAT)
            }

            const workType = this.request.workType
            this.selectedWorkType = []
            if (workType) {
              const strings = workType.split(',')
              for (let i = 0; i < strings.length; i++) {
                const valueByKey = this.getValueByKey(this.workTypeList, strings[i])
                this.selectedWorkType.push(valueByKey)
              }
            }
            const equipment = this.request.equipments
            this.selectedEquipments = []
            if (equipment) {
              const strings = equipment.split(',')
              this.selectedEquipments = this.getSelectedEquipments(strings)
            }

            const trailerStatuses = this.request.trailerStatus
            this.selectedStatus = []
            if (trailerStatuses) {
              this.selectedStatus = trailerStatuses.split(',')
            }

            const loadTypes = this.request.loadType
            this.selectedLoadType = []
            if (loadTypes) {
              this.selectedLoadType = loadTypes.split(',')
            }

            const driverTypes = this.request.driverType
            this.selectedDriverType = []
            if (driverTypes) {
              this.selectedDriverType = driverTypes.split(',')
            }

            this.selectedDrivers = this.request.drivers
          }
          this.$loading.hide()
        })
        .catch(e => {
          this.$loading.hide()
        })
    },
    hide () {
      this.$router.push('/requests')
      this.cloneRequest = false
    },
    resetDeparture () {
      if (!this.selectedStartDate) {
        this.selectedTime = null
      }
      this.updateHourDiff()
    },
    updateHourDiff () {
      if (this.selectedStartDate && this.selectedTime) {
        const end = this.selectedStartDate + ' ' + this.selectedTime
        const startDateWithTimeZone = moment.tz(this.request.timeZone)
        const endDateWithTimeZone = moment.tz(end, LONG_DATE_FORMAT, this.request.timeZone)
        const duration = moment.duration(endDateWithTimeZone.diff(startDateWithTimeZone))
        this.hourDiff = duration.humanize()
        if (endDateWithTimeZone.diff(startDateWithTimeZone) < 0) {
          this.hourDiff = ''
          return false
        }
      } else {
        this.hourDiff = ''
        return true
      }
      return true
    },
    loadTimeOptions () {
      const locale = 'en'
      moment.locale(locale)
      for (let hour = 0; hour < 24; hour++) {
        this.hourMinutes.push(moment({ hour }).format(HOUR_FORMAT))
        this.hourMinutes.push(
          moment({
            hour,
            minute: 30
          }).format(HOUR_FORMAT)
        )
      }
    },
    getValueByKey (array, val) {
      return array.filter(item => {
        return item.value === val
      })[0]
    },
    getValues: function (array) {
      return array && array.length > 0 ? array.join(',') : ''
    },
    toEquipmentStr: function (array) {
      const result = []
      array.forEach(arr => {
        if (arr.value === EQUIPMENTS.TRAILER_53.value) {
          result.push(TRAILER_53_STR)
        } else if (arr.value === EQUIPMENTS.TRAILER_28.value) {
          result.push(TRAILER_28_STR)
        } else {
          result.push(arr.value)
        }
      })
      if (result.length === 0) {
        result.push(TRAILER_53_STR)
      }
      return result.join(',')
    },
    getSelectedEquipments: function (array) {
      const result = []
      if (array.includes(EQUIPMENTS.TRAILER_53.value)) {
        result.push(EQUIPMENTS.TRAILER_53)
      }
      if (array.includes(EQUIPMENTS.CONTAINER_53.value)) {
        result.push(EQUIPMENTS.CONTAINER_53)
      }
      if (array.includes(EQUIPMENTS.TRAILER_28.value)) {
        result.push(EQUIPMENTS.TRAILER_28)
      }
      if (array.includes(EQUIPMENTS.TRUCK_26.value)) {
        result.push(EQUIPMENTS.TRUCK_26)
      }
      return result
    },
    convertLocations: function (array) {
      if (!array || array.length === 0) {
        return []
      }
      const locations = []
      for (let i = 0; i < array.length; i++) {
        locations.push(array[i].label)
      }
      return locations
    },
    onSubmit (evt) {
      evt.preventDefault()
      if (this.disabled) {
        this.hide()
        return false
      }
      if (this.$v.selectedOrigin.$invalid || !this.selectedOrigin.label) {
        this.$v.$touch()
        this.$toastr.error('Please select an origin')
        return false
      }
      if (this.$v.request.radius.$invalid) {
        this.$v.$touch()
        this.$toastr.error('Enter radius minimum 25, up to 100')
        return false
      }
      if (!this.validateRange(this.request.duration.min, this.request.duration.max)) {
        this.$toastr.error('Duration max. value should be greater than min. value')
        return false
      }
      if (!this.validateRange(this.request.distance.min, this.request.distance.max)) {
        this.$toastr.error('Distance max. value should be greater than min. value')
        return false
      }
      if (!this.validateStops()) {
        this.$toastr.error('Max. stop should be greater than min. stop')
        return false
      }
      if (!this.validateDeparture()) {
        this.$toastr.error('Selected departure time is incorrect')
        return false
      }
      if (!this.updateHourDiff()) {
        this.$toastr.error('Selected departure time is already expired')
        return false
      }
      const pricePerDistance = this.request.pricePerDistance
      if (!pricePerDistance) {
        this.request.pricePerDistance = 0
      } else if (pricePerDistance < 0) {
        this.$toastr.error('Price per distance cannot be negative')
        return false
      } else if (pricePerDistance < MIN_PRICE_PER_MILE) {
        this.$toastr.error('The price/mile entered is too low')
        return false
      } else if (pricePerDistance > MAX_PRICE_PER_MILE) {
        this.$toastr.error('The price/mile entered is too high')
        return false
      }
      const price = this.request.price
      if (!price) {
        this.request.price = 0
      } else if (price < 0) {
        this.$toastr.error('Price cannot be negative')
        return false
      } else if (price < MIN_PRICE) {
        this.$toastr.error('The price entered is too low')
        return false
      }
      if (pricePerDistance <= WARNING_PRICE) {
        this.warningMessage = 'Entered price/mile is too low.'
        this.showWarningModal()
      } else {
        this.showWarningMessages(evt)
      }
    },
    showWarningMessages (evt) {
      evt.preventDefault()
      this.warningMessage = ''
      if (this.selectedDestinations.length === 0 && this.selectedExcludedLocations.length === 0 && !this.emptyDestination) {
        this.warningMessage = 'No destinations have been selected'
        this.emptyDestination = true
        this.showWarningModal()
      } else if (this.request.radius > 50 && !this.radiusOk) {
        this.warningMessage = 'Radius is calculated in air miles and actual travel distance will be higher. It is advised to put 50 miles or less for the radius filter, otherwise driver may not be on time to pickup for booked load.'
        this.radiusOk = true
        this.showWarningModal()
      } else if (!this.validateTripLength() && !this.tripLengthOk) {
        this.warningMessage = this.request.tripLength === 'DURATION' ? 'Are you sure you have set correct duration values?' : 'Are you sure you have set correct distance values?'
        this.tripLengthOk = true
        this.showWarningModal()
      } else {
        this.createRequest()
      }
    },
    createRequest: function () {
      this.closeWarningModal()
      const reqObj = this.buildRequestObject()
      this.submitted = true
      this.$loading.show()
      this.axios.post('api/create-request', reqObj)
        .then(res => {
          this.submitted = false
          if (res && res.status === 200) {
            this.$toastr.success(this.id ? 'Updated successfully' : 'Created successfully')
            this.$router.push('/requests')
            this.$loading.hide()
          } else {
            this.$loading.hide()
            this.$toastr.error(res.data.message)
          }
        }).catch((error) => {
          this.submitted = false
          if (error.response.status === 403) {
            this.$toastr.info(error.response.data.message)
          } else if (error.response && error.response.data.message) {
            this.$toastr.error(error.response.data.message)
          }
          this.$loading.hide()
        })
    },
    buildRequestObject () {
      this.request.startDate = 0
      if (this.selectedStartDate && this.selectedTime) {
        const startDateStr = this.selectedStartDate + ' ' + this.selectedTime
        const dateWithTimeZone = moment.tz(startDateStr, LONG_DATE_FORMAT, this.request.timeZone)
        this.request.startDate = dateWithTimeZone.unix() * 1000
      }
      const reqObj = {
        ...this.request,
        id: this.cloneRequest ? null : this.id,
        origin: this.selectedOrigin.label,
        destinations: this.convertLocations(this.selectedDestinations),
        excludedLocations: this.convertLocations(this.selectedExcludedLocations),
        excludedOrigins: this.convertLocations(this.selectedExcludedOrigins),
        excludedFacilities: this.selectedExcludedFacilities,
        workType: this.selectedWorkType.map(item => item.value).join(','),
        trailerStatus: this.getValues(this.selectedStatus),
        loadType: this.getValues(this.selectedLoadType),
        driverType: this.getValues(this.selectedDriverType),
        status: this.id ? this.status : REQUEST_STATUS_ACTIVE,
        drivers: this.selectedDrivers,
        equipment: this.toEquipmentStr(this.selectedEquipments)
      }
      return reqObj
    },
    searchWarehouses (search) {
      if (!search || search.length < 2) {
        return
      }
      this.$refs.excludedFacilities.mutableLoading = true
      this.axios.get('api/facilities/search/' + search)
        .then((response) => {
          if (response.data && response.data.facilities) {
            const list = []
            response.data.facilities.forEach(function (item) {
              list.push({
                label: item.label,
                value: item.value
              })
            })
            this.excludedFacilities = list
          }
          this.$refs.excludedFacilities.mutableLoading = false
        })
    },
    searchLocations (search, type) {
      if (!search || search.length < 2) {
        return
      }
      if (search.length < 3) {
        const locs = STATES.filter((state) => state.value.startsWith(search.toUpperCase()))
          .map(stateValue => stateValue.text + ', ' + stateValue.value)
        if (locs && locs.length > 0) {
          this.setLocationOptions(locs, type)
          return
        }
      }
      this.$refs[type].mutableLoading = true
      this.axios.get('api/location/search/' + search)
        .then((response) => {
          if (response.data && response.data.locations) {
            this.setLocationOptions(response.data.locations, type)
          }
          this.$refs[type].mutableLoading = false
        })
    },
    setLocationOptions (locations, type) {
      const list = []
      locations.forEach(function (name) {
        list.push({
          label: name
        })
      })
      if (type === 'origin') {
        this.origins = list
      } else if (type === 'destinations') {
        this.multiplDestinations = list
      } else if (type === 'excludedDestinations') {
        this.excludedDestinations = list
      } else if (type === 'excludedOrigins') {
        this.excludedOrigins = list
      }
    },
    showWarningModal () {
      this.$refs.warningModal.show()
    },
    closeWarningModal () {
      this.$nextTick(() => {
        this.$refs.warningModal.hide()
      })
    },
    resetLengthValues (duration) {
      if (duration) {
        this.request.distance = {
          min: null,
          max: null
        }
      } else {
        this.request.duration = {
          min: null,
          max: null
        }
      }
    },
    validateTripLength () {
      if (this.request.tripLength === 'DURATION') {
        const min = this.request.duration.min
        const max = this.request.duration.max
        const hasValue = min > 0 || min > 0
        if (hasValue && (min > 24 || max > 24)) {
          return false
        }
      } else {
        const min = this.request.distance.min
        const max = this.request.distance.max
        const hasValue = min > 0 || min > 0
        if (hasValue && (min < 150 || max < 150)) {
          return false
        }
      }
      return true
    },
    validateRange (min, max) {
      return !(min > 0 && max > 0 && min > max)
    },
    validateDeparture () {
      if (this.selectedStartDate || this.selectedTime) {
        return this.selectedStartDate && this.selectedTime && this.request.timeZone
      }
      return true
    },
    validateStops () {
      const min = this.request.stops.min
      const max = this.request.stops.max
      if (min > 0 && max > 0 && min > max) {
        this.$refs.stopMin.$el.classList.add('is-invalid')
        this.$refs.stopMax.$el.classList.add('is-invalid')
        return false
      } else {
        this.$refs.stopMin.$el.classList.remove('is-invalid')
        this.$refs.stopMax.$el.classList.remove('is-invalid')
      }
      if (max === 2) {
        this.request.excludeNonDestinations = false
      }
      return true
    },
    onlyNumber ($event) {
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault()
      }
    },
    searchDrivers (key) {
      this.$refs.drivers.mutableLoading = true
      const payload = {
        searchKey: key,
        start: 0,
        limit: 10
      }
      this.axios.post('api/drivers', payload)
        .then((response) => {
          if (response.data && response.data.count > 0) {
            const list = []
            response.data.items.forEach(function (driver) {
              list.push({
                label: driver.FirstName + ' ' + driver.LastName,
                value: driver.CustomerId
              })
            })
            this.driverList = list
          }
          this.$refs.drivers.mutableLoading = false
        })
    },
    changePrice (val, reference) {
      if (reference === 'pricePerMile') {
        if (val < MIN_PRICE_PER_MILE) {
          this.pricePerMilError = true
          this.$refs[reference].$el.classList.add('is-invalid')
        } else {
          this.$refs[reference].$el.classList.remove('is-invalid')
          this.pricePerMilError = false
        }
      } else {
        if (val < MIN_PRICE) {
          this.priceError = true
          this.$refs[reference].$el.classList.add('is-invalid')
        } else {
          this.$refs[reference].$el.classList.remove('is-invalid')
          this.priceError = false
        }
      }
    }
  },
  computed: {
    showMatchingTrips () {
      return !this.id || this.request.status === ACTIVE_REQUESTS || this.request.status === INACTIVE_REQUESTS
    }
  },
  validations: {
    selectedOrigin: {
      required
    },
    request: {
      radius: {
        between: between(25, 100)
      }
    }
  }
}

</script>

<style scoped>
.load-request-form label, .load-request-form legend.col-form-label {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.stem-time-info {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
</style>
